import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import axios from "axios";
import "@/App.css";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import CountryLogin from "@/pages/CountryLogin";
import CountryVote from "@/pages/CountryVote";
import Visualizer from "@/pages/Visualizer";
import ProtectedRoute from "@/components/ProtectedRoute";

// Send cookies (httpOnly admin session) with every request
axios.defaults.withCredentials = true;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route path="/country-login" element={<CountryLogin />} />
          <Route path="/country-vote" element={<CountryVote />} />
          <Route path="/visualizer" element={<Visualizer />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;